import React from "react";

interface MiscPlayerChipProps {
  info: Object;
}

const MiscPlayerChip: React.FC<MiscPlayerChipProps> = ({ info }) => {
  const { rate, description } = info;

  const opacity =
    {
      "+++": 1,
      "++": 0.9,
      "+": 0.8,
      "-": 0.8,
      "--": 0.9,
      "---": 1,
    }[rate] || 1;

  return (
    <div
      className={
        "d-inline-flex w-fit-content align-items-center text-small px-2 me-1 " +
        (rate.includes("+") ? "main-blue-color-background" : "main-pink-color-background")
      }
      style={{ opacity: opacity, paddingBottom: "2px", paddingTop: "2px" }}
    >
      <div className={`d-inline-block font-bold text-center pe-1`}>
        <b>{rate}</b>
      </div>
      <span>{description}</span>
    </div>
  );
};

export default MiscPlayerChip;
